import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { auth } from './firebaseApp';
import VueClipboard from 'vue-clipboard2';

Vue.use(VueClipboard);

Vue.config.productionTip = false;

// Enable when using the simulator
// firebaseApp.functions('europe-west3').useFunctionsEmulator('http://localhost:5001');

const unsubscribe = auth.onAuthStateChanged(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
  unsubscribe();
});
